import { apiRequest, backendUrl } from '../../utils/apiRequest';

const path = '/buow_api/systemconfiguration';
const fullBase = () => `${backendUrl()}${path}`;

export const createSearchPage = (data) =>
  apiRequest({ method: 'post', url: fullBase(), data, errorPrefix: 'Error in scanOnDemandService.js claimJob()', attachError: true });

export const updateSearchData = (data) =>
  apiRequest({ method: 'put', url: `${fullBase()}/${data.id}`, data, errorPrefix: 'Error in scanOnDemandService.js claimJob()', attachError: true });

export const deleteSearchData = (data) =>
  apiRequest({ method: 'delete', url: `${fullBase()}/${data.id}`, errorPrefix: 'Error', attachError: true });

export const onSearchFileData = (data, { signal } = {}) => {
  let url = `${fullBase()}/`;
  if (data.text !== '' && data.column === '' && data.order === '') {
    url += `search?keywords=${data.text}`;
  } else {
    url += `search?keywords=${data.text}&sortOn=${data.column}&sortOrder=${data.order}`;
  }
  return apiRequest({ method: 'get', url, errorPrefix: 'Error in get messages ', signal });
};

export const searchPageColumnsAPI = () => {
  const defaultFolderLevel = window.env.REACT_APP_DEFAULT_SEARCH_GROUP_LEVEL;
  return apiRequest({
    method: 'get',
    url: `${backendUrl()}/buow_api/systemfolderoptions?level=${defaultFolderLevel || ''}`,
    errorPrefix: 'Error in get messages ',
  });
};

export const fetchAdditionalMetadata = (buowId) =>
  apiRequest({ method: 'get', url: `${backendUrl()}/buow_api/batchxwalk/buow/${buowId}`, errorPrefix: 'Error in get messages ' });
